import { controls, currencyToNumber, grouped } from "../../controls";

const assignedIssues = {
  label: "assignedIssues",
  starting: true,
  url: "assignedIssues",
  pageLabel: "Assigned Issues",
  pageType: "history",
  visitingBranches: true,
  // filteraction: true,
  filter: [
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "assignedIssues",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },

    displayColumns: [



    ]
  }
};

export default assignedIssues;